import { render, staticRenderFns } from "./ValidatableMailList.vue?vue&type=template&id=2d914d9e&"
import script from "./ValidatableMailList.vue?vue&type=script&lang=js&"
export * from "./ValidatableMailList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports